import * as ActionType from "./shorts.type";

const initialState = {
  shortsData: [],
  totalShorts: null,
};

export const shortsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_SHORTS:
      return {
        ...state,
        shortsData: action.payload.shortsData,
        totalShorts: action.payload.totalShorts,
      };


    case ActionType.IMPORT_SHORT:
      const importedVideo = action.payload.data;


      const newVideoData = {
        ...importedVideo,
        fullName: importedVideo.userId.fullName,
        uniqueId: importedVideo.userId.uniqueId,
      };

      const updatedShortsData = [newVideoData, ...state.shortsData];


      return {
        ...state,
        shortsData: updatedShortsData,
        totalShorts: action.payload.totalNumber,
      };

      case ActionType.LIVE_SHORT_TOGGLE:
        console.log('action.payload', action.payload)
        const userIds = action.payload.id;
        return {
          ...state,
          shortsData: state.shortsData.map((data) => {
            if (userIds?.includes(data._id)) {
              const matchingUserData = action.payload.data.videos.find(
                (shortsData) => shortsData._id === data._id
              );
  
              console.log('matchingUserData', matchingUserData?.isVideoPublished)
              return {
                ...data,
                isVideoPublished: matchingUserData.isVideoPublished,
              };
            }
            return data;
          }),
        };

    case ActionType.EDIT_SHORT:
      const updatedVideoData = state.shortsData.map((item) => {
        if (item._id === action.payload.data._id) {
          return {
            ...action.payload.data,
            title: action.payload.data.title,
            fullName: action.payload.fullName,
            userId:action.payload.data?.userId?._id,
            image: action.payload.data.userId.image,
            uniqueId: action.payload.data?.uniqueVideoId,
          };
        }
        return item;
      });
      console.log("updatedVideoData",action.payload.data);
      console.log("updatedVideoData",updatedVideoData);
      return {
        ...state,
        shortsData: updatedVideoData,
      };
    case ActionType.DELETE_SHORT:
      return {
        ...state,
        shortsData: state.shortsData.filter(
          (data) => !action.payload.id.includes(data._id)
        ),
      };
    default:
      return state;
  }
};
